module.exports = __webpack_public_path__ + "img/3.3f5b25ea.png";